var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search Results- unselected",
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    transform: "translate(-1020 -410)",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AW Area"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -489.5,
    y: -267.5,
    width: 825,
    height: 559,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -489.5,
    y: -267.5,
    width: 825,
    height: 559,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dialog"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sheet /  Scrim"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Scrim",
    opacity: 0.4,
    x: -1020,
    y: -410,
    width: 1366,
    height: 768,
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Base",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1020,
    y: -410,
    width: 1366,
    height: 768,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "back",
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16 -17C-16 -18.1046 -15.1046 -19 -14 -19H99C100.105 -19 101 -18.1046 101 -17V35C101 36.1046 100.105 37 99 37H-14C-15.1046 37 -16 36.1046 -16 35V-17Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/back_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/back_24px_2",
    d: "M8.55556 4.88889V0L0 8.55555L8.55556 17.1111V12.1C14.6667 12.1 18.9444 14.0556 22 18.3333C20.7778 12.2222 17.1111 6.11111 8.55556 4.88889Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -1,
    y: -3,
    width: 24,
    height: 24,
    fill: "#677D8A"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M-14 -18H99V-20H-14V-18ZM100 -17V35H102V-17H100ZM99 36H-14V38H99V36ZM-15 35V-17H-17V35H-15ZM-14 36C-14.5523 36 -15 35.5523 -15 35H-17C-17 36.6569 -15.6569 38 -14 38V36ZM100 35C100 35.5523 99.5523 36 99 36V38C100.657 38 102 36.6569 102 35H100ZM99 -18C99.5523 -18 100 -17.5523 100 -17H102C102 -18.6569 100.657 -20 99 -20V-18ZM-14 -20C-15.6569 -20 -17 -18.6569 -17 -17H-15C-15 -17.5523 -14.5523 -18 -14 -18V-20Z",
    fill: "none"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -1040,
    y: -435,
    width: 1406,
    height: 808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: -18,
    y: -20,
    width: 121,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    fill: "white",
    transform: "translate(-1020 -410)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackIcon);
export default __webpack_public_path__ + "static/media/go-back-icon.934067fd.svg";
export { ForwardRef as ReactComponent };